import React, {Fragment} from "react"
import {Button, Checkbox, Divider, Form, Input, InputNumber, Radio, Select, Typography,} from "antd";
import {EuroOutlined} from "@ant-design/icons"
import {getDeviseSymbol} from "../../i18n";
import {t} from "@lingui/core/macro"
import {Trans} from "@lingui/react/macro"

const {Text}=Typography

export default class General  extends React.Component{

    state={
        nbMonth:12
    }

    render()
    {
        const {config,context,devise}=this.props

        return (
            <div style={{display: "flex", alignItems: "center", flexDirection: "column", padding: "20px 10%"}}>

                <Form.Item
                    label={t`Montant`}
                    name="montant"
                    rules={[{required: true, message: t`Ce champ est obligatoire`}]}
                >
                    <InputNumber size="large" min={1} placeholder={t`Montant`} addonAfter={getDeviseSymbol(context,devise)}/>
                </Form.Item>

                <Form.Item label={t`Je donne :`} name="abo">
                    <Radio.Group optionType="button" buttonStyle="solid">
                        <Radio value={false}>{t`Une fois`}</Radio>
                        <Radio value={true}>{t`Tous les mois`}</Radio>
                    </Radio.Group>
                </Form.Item>

                <Form.Item noStyle shouldUpdate>
                    {(e) => {
                        if (!e.getFieldValue("abo")) {
                            return null
                        }

                        const value = e.getFieldValue("nbMonth")
                        const montant = e.getFieldValue("montant")

                        return (
                            <Fragment>
                                <select disabled={this.props.disabled} className={"form-control"} value={value}
                                        onChange={(v) => e.setFieldValue("nbMonth", v.target.value)}>
                                    <option
                                        value={0}>{t`En continue - résiliable à tout moment`}</option>
                                    {Array.from(Array(35).keys()).map((i) => {
                                        return <option value={i + 2}>{t`pendant ${i + 2} mois`}</option>
                                    }).reverse()}
                                </select>

                                {value > 0 && (
                                    <div style={{marginTop: 15, textAlign: "center"}}>
                                        <Text>{t`Soit un total de : ${parseFloat(montant * value).toFixed(2)}${getDeviseSymbol(context, devise)}`}</Text>
                                    </div>
                                )}

                            </Fragment>
                        )
                    }}
                </Form.Item>
            </div>

        )
    }
}
